import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  padding: 8px 40px;
  background-color: ${theme.colors.neutral.white};
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const FileInput = styled.input`
  display: none;
`
